import { signOut } from "firebase/auth";
import { auth } from "../../config/firebase";
import { signinAPI, signupAPI } from "../../api/userApi";
import { setTokens } from "../../utils/tokens";

export const registerUser = async (email, password, referralId) => {
  return new Promise((resolve, reject) => {
    // Просто реєструємо на бекенді без Firebase
    const signupData = {
      email,
      password,
    };
    if (referralId) {
      signupData.referralId = referralId;
    }
    
    signupAPI(signupData)
      .then((response) => {
        // New API response format
        if (response.data.success) {
          const { user: userData, tokens } = response.data;

          // Store tokens with 30-day expiration (тільки JWT токени)
          setTokens({
            access: tokens.access,
            refresh: tokens.refresh,
          });

          // Користувач отримає email з посиланням для верифікації
          resolve({
            success: true,
            user: userData,
            tokens: tokens,
            message: response.data.message || "Registration successful! Please check your email to verify your account.",
          });
        } else {
          reject(response.data.message || "Registration failed");
        }
      })
      .catch((error) => {
        reject(error.response?.data?.message || "Registration failed");
      });
  });
};
export const loginUser = async (email, password, remember = false) => {
  return new Promise((resolve, reject) => {
    // Викликаємо бекенд API з паролем
    // Бекенд обробляє rate limiting по IP та email
    signinAPI({
      email,
      password,
      remember,
    })
      .then((res) => {
        // Якщо бек каже, що потрібна 2FA — повертаємо дані для екрану 2FA
        if (res?.data?.status === "pending_2fa") {
          return resolve({
            twoFA: true,
            userId: res.data.userId,
            twofaToken: res.data.twofaToken || null,
            cooldown: res.data.cooldown ?? 60,
            remember, // ⬅️ збережемо вибір для verify2FA
          });
        }

        // Перевіряємо email verification
        // Бекенд повертає помилку, якщо email не верифікований
        if (res?.data?.user?.validated === false) {
          return reject("Please verify your email!");
        }

        // Успішний логін без 2FA
        resolve({
          ...res.data,
        });
      })
      .catch((err) => {
        // Обробка помилок від бека
        const errorMessage = err?.response?.data?.message || err?.message;
        
        // Rate limit помилка від бека
        if (err?.response?.status === 429) {
          const retryAfter = err?.response?.data?.retryAfter || 3600;
          reject(`Too many login attempts. Please try again in ${Math.ceil(retryAfter / 60)} minutes.`);
          return;
        }
        
        // Перевіряємо, чи це помилка про неверифікований email
        if (errorMessage && (
          errorMessage.toLowerCase().includes("verify your email") ||
          errorMessage.toLowerCase().includes("email not verified") ||
          errorMessage.toLowerCase().includes("email verification")
        )) {
          return reject("Please verify your email!");
        }
        
        // Інші помилки
        reject(errorMessage || "Incorrect email or password");
      });
  });
};

export const logoutUser = () => signOut(auth);

export const sendTokenToBackend = async (token) => {
  const res = await fetch("http://localhost:8000/api/auth", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.json();
};
